import { Component, inject } from '@angular/core';
import { PageComponent } from '@tytapp/common';
import { ActivatedRoute } from '@angular/router';

import { ApiNewsletterOptins, UsersApi, ApiCommunicationPref, ApiUser, CommunicationPrefsApi, ApiPostUsersSignupNewsletter } from '@tytapp/api';

@Component({
  selector: 'app-newsletter-form',
  templateUrl: './newsletter-form.component.html',
  styleUrls: ['./newsletter-form.component.scss']
})
export class NewsletterFormComponent extends PageComponent {
  private route = inject(ActivatedRoute);
  private usersApi = inject(UsersApi);
  private communicationPrefsApi = inject(CommunicationPrefsApi);

  inputFields = {};
  newsletterTypesForDisplay = {};

  newsletterTypes : ApiNewsletterOptins = <any>{};
  showCheckBoxes: boolean;
  isSubmitting = false;
  success = false;
  loading = true;

  email : string;
  firstname : string;
  lastname : string;
  phonenumber : string;

  submitText: string;
  checkboxDescription: string;

  communicationPrefs: ApiCommunicationPref[];

  get emailPrefs(): ApiCommunicationPref[] {
    if (!this.communicationPrefs)
        return [];

    return this.communicationPrefs.filter(x => x.provider === 'email');
  }

  user: ApiUser;

  async init() {
    this.shell.chromeless = true;
    this.route.queryParamMap.subscribe(async params => {
      
      this.communicationPrefs = await this.communicationPrefsApi.getAvailableCommunicationPrefs().toPromise();

      (params.get('fields') || 'email').split(',').forEach((field) => this.inputFields[field] = field);

      this.showCheckBoxes = ['true', '1'].includes(params.get('show_checkboxes'));
      this.submitText = params.get('submit_text') || 'Sign me up';
      this.checkboxDescription = params.get('checkbox_description');
      let newsletterTypesParam = params.get('newsletter_types');
      let defaultChecks = (params.get('default_checks') || '').split(',');

      if (newsletterTypesParam) {
        newsletterTypesParam.split(",").forEach((newsletter_type) => {
          this.newsletterTypesForDisplay[newsletter_type] = newsletter_type;
          this.newsletterTypes[newsletter_type] = !this.showCheckBoxes;
        });
      }

      for (let check of defaultChecks)
        this.emailPrefs.filter(x => x.provider_id === check).forEach(x => x.allowed = true);

      if (defaultChecks.includes('newsletter_daily'))
        this.emailPrefs.find(x => x.provider_id === 'newsletter').allowed = true;

      this.loading = false;
    });
  }

  get isValid() {
    if (!this.email || !this.email.includes('@'))
      return false;
    
    if (this.inputFields['first_name'] && !this.firstname)
      return false;

    if (this.inputFields['last_name'] && !this.lastname)
      return false;

    if (this.inputFields['phone'] && !this.phonenumber)
      return false;

    return true;
  }

  validFormCheck() {
    return this.inputFields['email'] || false;
  }

  async submitRequest(request: ApiPostUsersSignupNewsletter) {
    await this.usersApi.signupNewsletter(request).toPromise();
  }

  async submit() {
    if (this.isSubmitting || !this.isValid)
      return;

    // call the api
    try {
      this.isSubmitting = true;
      await this.submitRequest({
        email: this.email,
        newsletter_types: 
          this.emailPrefs
            .filter(x => x.allowed)
            .reduce<Record<string,boolean>>((record, pref) => (record[pref.provider_id] = true, record), {}),
        first_name: this.firstname,
        last_name: this.lastname,
        phone_number: this.phonenumber
      });
      this.success = true;
    } catch (e) {
      if (e.json)
        e = e.json();
      
      console.log('Error while submitting: ', e);
      this.showError(e.message || e.error || 'An unknown error occurred, please try again later.');
      return;
    } finally {
      this.isSubmitting = false;
    }
  }

  get checkedNewsletters(): string[] {
    return this.communicationPrefs.filter(c => c.allowed).map(c => c.provider_id);
  }
}
